import { ApiResponse } from "../Models/api-response.model";
import { GetAllDto } from "../Shared/dto/get-all-dto";
import { ApiUrls, BindQuery } from "./api-urls";
import { ApplicationService, HttpService } from "./application.service"

export const PaymentService = {
    save: (data: any) => {
        if (data.id) return ApplicationService.put(ApiUrls.PAYMENT_PUT(data.id), data);
        return ApplicationService.post<any>(ApiUrls.PAYMENT_POST, data);
    },
    getReceivedData: (getAllDto: GetAllDto) => {
        return ApplicationService.get<any>(BindQuery(ApiUrls.PAYMENT_GET, getAllDto));
    },
    getReceiptNo: () => {
        return ApplicationService.get<any>(ApiUrls.PAYMENT_RECEIPTNO)
    },
    delete: (paymentId: number) => {
        return ApplicationService.delete<any>(ApiUrls.PAYMENT_DELETE(paymentId));
    },
    getById: (paymentId: number) => {
        return ApplicationService.get<any>(ApiUrls.PAYMENT_BY_ID(paymentId));
    },
    getReceivableData: (getAllDto: GetAllDto) => {
        return ApplicationService.get<any>(BindQuery(ApiUrls.PAYMENT_RECEIVABLE_GET, getAllDto));
    },
}